export const questionConstants ={
    
    ADD_QUESTION_REQUEST: 'ADD_QUESTION_REQUEST',
    ADD_QUESTION_SUCCESS: 'ADD_QUESTION_SUCCESS',
    ADD_QUESTION_FAILURE: 'ADD_QUESTION_FAILURE',

    ADD_ANSWER_REQUEST: 'ADD_ANSWER_REQUEST',
    ADD_ANSWER_SUCCESS: 'ADD_ANSWER_SUCCESS',
    ADD_ANSWER_FAILURE: 'ADD_ANSWER_FAILURE',

    GET_QUESTION_REQUEST: 'GET_QUESTION_REQUEST',
    GET_QUESTION_SUCCESS: 'GET_QUESTION_SUCCESS',
    GET_QUESTION_FAILURE: 'GET_QUESTION_FAILURE',

    DELETE_QUESTION_REQUEST: 'DELETE_QUESTION_REQUEST',
    DELETE_QUESTION_SUCCESS: 'DELETE_QUESTION_SUCCESS',
    DELETE_QUESTION_FAILURE: 'DELETE_QUESTION_FAILURE',

    GET_QUESTION_DETAILS_REQUEST: 'GET_QUESTION_DETAILS_REQUEST',
    GET_QUESTION_DETAILS_SUCCESS: 'GET_QUESTION_DETAILS_SUCCESS',
    GET_QUESTION_DETAILS_FAILURE: 'GET_QUESTION_DETAILS_FAILURE'
    
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/questionConstants.js